//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Api, {API_ORIGIN,getTokenSNO} from '../libs/Api';
import fields, {keyId} from "../libs/fields";
import fillList from "../components/fillList";
    export default {
        name: 'Main',
        components:{fillList},
        data() {
            return {
              fields,
              fillData:{},
              showDetail:false,
              queryResult:[],
              oldSearch:null,
              userInfo:null,
              showAlert:false,
              canInput:true,
              hisBackEvt:null,
              currentPage:1,
              total:0,
              totalPage:1,
              pageNo:10,
              backgroundImage:'url(' + require('./assets/imgs/'+(this.$root.isMobile?'mobile':'banner')+'.png') +') !important',
              loading:false,
              show_num:[],
              cap:null,
              log:null,//打印信息
              alertCb:null,
              cannotClose:false,
            };
        },
      watch:{
        showAlert(v){
            if(v)document.getElementsByTagName('body')[0].style.overflow='hidden';
            else document.getElementsByTagName('body')[0].style.overflow='overlay';
          }
      },
      computed:{
        handleFieldEncode(){
          const autoGetInfoKeysCombine=['xm,zjhm','xm,sfzh']
          let combineCurrent=[],combineStr=autoGetInfoKeysCombine.join(',')+',',findObj={},needLogined=false
          
          this.fields.searchFields.map(sf=>{
            combineCurrent=[]//['xm','zjhm']
            findObj={}
            sf.list.map((f,fi)=>{
              if(f.prop && combineStr.includes(f.prop+',')){
                if(combineCurrent.length)findObj[combineCurrent.indexOf(f.prop)]=fi
                else{
                  for(let i of autoGetInfoKeysCombine){
                    const ac=i.split(',')
                    if(ac.includes(f.prop)){
                      combineCurrent=ac
                      break
                    }
                  }
                  findObj[combineCurrent.indexOf(f.prop)]=fi
                }
              }
            })
            if(combineCurrent.length && Object.keys(findObj).length==combineCurrent.length){
              Object.values(findObj).map(vk=>sf.list[vk].edit=false)
              needLogined=true
              // this.fillData={xm:'请输入姓名',sfzh:'请输入身份证号',zjhm:'请输入证件号码'}
            }
          })
          return needLogined
        },
      },
        mounted () {
          /*console.log=(...data)=>{
            this.logMsg(data)
          }*/
          if(this.$root.isMobile){
            this.draw()
            const appContainer=document.querySelector('.app-container-content')
            appContainer.style.minHeight=appContainer.offsetHeight+'px'
            this.pageNo=100000000
            try{
              if(this.handleFieldEncode){
                /*IF_isNotDEBUG*/
                this.canInput=false
                this.cannotClose=true
                this.alertCb=this.goLogin
                lightAppJssdk.notification.hidePreloader ({
                  text: null, //loading 显示的字符，空表示不显示文字
                  success(data){},fail(data){}
                });
                this.getAppUserInfo()
                /*FI_isNotDEBUG*/
              }

            }catch (e) {}
          }
          else {
            try{
              this.centerRheight()
              if(this.handleFieldEncode){
                this.canInput=false
                IsLogin(userData=>this.getUserInfo(userData))
              }

              setTimeout(
                  ()=>{
                    $('.formCodeImg').click()
                    //region 1406
                  $(".hoverBt p").on("mouseenter",function () {
                    $(this).css("border-top","15px solid #2a344e");
                    $(this).next(".hidBox").fadeIn(200);
                    $(this).addClass("bacP")
                  });
                  $(".hoverBt").on("mouseleave",function () {
                    $(this).find(".hidBox").fadeOut(200)
                    $(this).find("p").css("border-top","15px solid #121d3b");
                    $(this).children("p").removeClass("bacP")
                  })
                  function screenWidth(){
                    var userAgentInfo = navigator.userAgent;
                    if (userAgentInfo.indexOf('iPhone')>0 || userAgentInfo.indexOf('iPad')>0) {
                      var creatMeta = document.createElement('meta');
                      creatMeta.name = 'viewport';
                      creatMeta.id   = 'viewport';
                      var screenWidth = parseInt(window.screen.width);
                      if (window.orientation == '-90' || window.orientation == '90') {
                        var scale = window.screen.height / 1200;
                        creatMeta.content = 'width=1200 ' + ', initial-scale = ' + scale;
                      } else {
                        var scale = screenWidth / 1200;
                        creatMeta.content = 'width=1200'  + ', initial-scale = ' + scale;
                      }
                      document.head.append(creatMeta);
                    }
                  }
                  screenWidth();

                  function nuValue(){
                    var nuurl = window.location.href;
                    var nusize = nuurl.indexOf('?');
                    var nuValue = nuurl.substring(nusize+1,nusize+11);
                    // console.log($('#iframeMain').attr('src')+nuValue);
                    if(nusize>1){
                      $('#iframeMain').attr('src',$('#iframeMain').attr('src')+'&'+nuValue);
                    }
                  }//nuValue();
                  //endregion
                  //region 1333.js
                    $(".InFixUl_wm").hover(function(){
                      $(this).find("div").show();
                    },function(){
                      $(this).find("div").hide();
                    });
                    $(".InFixUlMax_wm").hover(function(){
                      $(this).find("div").show();
                    },function(){
                      $(this).find("div").hide();
                    });

                    $("#myframe1").on("mouseleave", function(){

                      $("#myframe1").attr('src',mainDomain + '/fwmh/item/indexGR.do')
                    })
                    $("#myframe2").on("mouseleave", function(){

                      $("#myframe2").attr('src',mainDomain + '/fwmh/item/indexFR.do')
                    })

                    $(".InFixUlMax_mor").click(function(){
                      $(this).parents(".InFixUlMax").hide().siblings(".InFixUl").show();
                      $.cookie('InFixS','hide',{
                        expires:1,
                        path:'/',
                        domain:'www.gov.cn'
                      });
                    });
                    $(".InFixUl_mor").click(function(){
                      $(this).parents(".InFixUl").hide().siblings(".InFixUlMax").show();
                      $.cookie('InFixS','show',{
                        expires:1,
                        path:'/',
                        domain:'www.gov.cn'
                      });
                    });
                    if($.cookie('InFixS')==undefined || $.cookie('InFixS')=='show'){
                      $(".InFixUlMax").show();
                      $(".InFixUl").hide();
                    }else{
                      $(".InFixUlMax").hide();
                      $(".InFixUl").show();
                    }
                    //endregion
                },100)
            }catch (e) {}

          } 
          // this.draw()

        },
        methods: {
          logMsg(...params){
            this.log=(this.log||[]).concat(params.length>1?params:params[0])
          },
          getAppUserInfo(t){
            lightAppJssdk.user.getTicket({
              success:data=>{ //成功回调
                console.log('getTicket-success');
                if(data=='未登录'){//未登录
                  this.showAlert='当前未登录，请先登录'
                  return
                }
                lightAppJssdk.notification.showPreloader ({
                  text: "登录中..", //loading 显示的字符，空表示不显示文字
                  success(){},fail(){}
                });
                data=JSON.parse(data)
                getTokenSNO(data.ticket).then(res => {
                  lightAppJssdk.notification.hidePreloader ({
                    text: "登录中..", //loading 显示的字符，空表示不显示文字
                    success(){},fail(){}
                  });
                  if(!res.certNo){
                    this.showAlert='登录失败，请重试'
                    this.alertCb=()=>{
                      this.getAppUserInfo()
                    }
                    return
                  }
                  this.getUserInfo(res)
                }).catch(error => {
                  console.log('获取用户信息错误',error);
                });
              },
              fail:function(data){ //错误返回
                this.logMsg('getticket-fail')
              }
            });
          },
          goLogin(){
            lightAppJssdk.notification.showPreloader ({
              text: "登录中..", //loading 显示的字符，空表示不显示文字
              success(){},fail(){}
            });
            console.log('等待登录');
            lightAppJssdk.user.loginapp({
              success: data1 => { //成功回调
                  lightAppJssdk.notification.hidePreloader ({
                    success(){},fail(){}
                  });
                if(data1=='未登录'){
                  console.log('登录失败');
                  lightAppJssdk.notification.toast ({
                    text: "登录失败", //loading 显示的字符，空表示不显示文字
                    success(){},fail(){}
                  });
                  this.showAlert='当前未登录，请先登录'
                  return
                }
                console.log('登录成功，获取用户数据');
                data1=JSON.parse(data1)
                lightAppJssdk.notification.toast ({
                  text: "登录成功", //loading 显示的字符，空表示不显示文字
                  success(){},fail(){}
                });
                this.showAlert=false
                this.cannotClose=false
                this.getAppUserInfo(1)
              },
              fail: data1 => { //错误返回
                lightAppJssdk.notification.hidePreloader ({
                  text: "登录中..", //loading 显示的字符，空表示不显示文字
                  success(){},fail(){}
                });
              }
            });
          },
          getUserInfo(userData){
            this.canInput=true
            const fillData={}
            this.userInfo = userData
            fillData.zjhm = userData.des_idCard
            fillData.sfzh = userData.des_idCard
            fillData.xm = userData.des_userName
            this.fillData=fillData
          },
          doSearch(page=1,pageC=false){
            //{xm:'张小军',zjhm:'42092319850302621X'}
            let dev=false
            
            if(!this.canInput && !dev){
              try{
                openAlert('请先登录');
              }catch (e) {
                this.showAlert='请先登录'
              }
              return
            }
            let pData={...this.fillData,current_page:page,page_total:this.pageNo}

            if(pageC!==true){
              let empty=[]
              for(let s of this.fields.searchFields){
                for(let f of s.list){
                  if(f.required && !this.fillData[f.prop]){
                    empty.push(f.label+'未填写')
                  }
                }
              }
              if(!dev) {
                if (!this.cap) empty.push('验证码未填写')
                else if (this.$root.isMobile && this.cap.toUpperCase() != this.show_num.join('').toUpperCase()) empty.push('验证码不正确')
                else {
                  try {
                    const code = checkCode(this.cap);
                    if (code == 0 || code == 2) empty.push('验证码不正确')
                  } catch (e) {
                  }

                  // empty.push('验证码不正确')
                }
              }
              if(empty.length){
                this.showAlert='存在以下错误：<ol><li>'+empty.join('</li><li>')+'</li></ol>'
                return
              }
              if(this.userInfo){
                if(pData.hasOwnProperty('zjhm'))pData.zjhm=this.userInfo.certNo
                if(pData.hasOwnProperty('sfzh'))pData.sfzh=this.userInfo.certNo
                pData.xm=this.userInfo.userName
              }
              this.oldSearch={...this.fillData}
            }else{
              pData={...pData,...this.oldSearch}
            }
            this.loading=true
            this.currentPage=page
            this.cap=null

            Api(fields.appID, pData,keyId,this.$root.isMobile?API_ORIGIN.APP:API_ORIGIN.PC).then(d=>{
              if(!dev)$('.formCodeImg').click()
              if(this.fields.transform)d=this.fields.transform(d)
              this.loading=false
              this.total=(d[0]||{}).total||0
              this.totalPage=(this.total/this.pageNo|0)+(this.total % this.pageNo==0?-1:0)+1
              this.queryResult=d
              if(this.$root.isMobile) this.handleGoMobileDetail()
              if(!dev)this.centerRheight()
              this.showDetail=true
            })
          },
          drawCap() {
            // console.log(jmopenUrl+'/jmopen/verifyCode.do?width=100&height=55&random='+ Math.random());
            this.$refs.verifyImg.src=jmopenUrl+'/jmopen/verifyCode.do?width=100&height=55&random='+ Math.random();
          },
          // 验证码
          draw() {
            this.show_num=[]
            let show_num=this.show_num
            let canvas = document.getElementById("canvas");
            let canvas_width = canvas.width;
            let canvas_height = canvas.height;
            let context = canvas.getContext("2d");
            let sCode = "A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0";
            let aCode = sCode.split(",");
            let aLength = aCode.length;
            context.clearRect(0,0,canvas_width, canvas_height)
            const randomColor=()=> {
              let r = Math.floor(Math.random() * 256);
              let g = Math.floor(Math.random() * 256);
              let b = Math.floor(Math.random() * 256);
              return "rgb(" + r + "," + g + "," + b + ")";
            }
            for (let i = 0; i <= 3; i++) {
              let j = Math.floor(Math.random() * aLength);
              let deg = Math.random() * 30 * Math.PI / 180;
              let txt = aCode[j];
              show_num[i] = txt.toLowerCase();
              let x = 10 + i * 20;
              let y = 20 + Math.random() * 8;
              context.font = "bold 23px ΢���ź�";

              context.translate(x, y);
              context.rotate(deg);

              context.fillStyle = randomColor();
              context.fillText(txt, 0, 0);

              context.rotate(-deg);
              context.translate(-x, -y);
            }
            this.show_num=show_num
            for (let i = 0; i <= 5; i++) {
              context.strokeStyle = randomColor();
              context.beginPath();
              context.moveTo(Math.random() * canvas_width, Math.random() * canvas_height);
              context.lineTo(Math.random() * canvas_width, Math.random() * canvas_height);
              context.stroke();
            }
            for (let i = 0; i <= 30; i++) {
              context.strokeStyle = randomColor();
              context.beginPath();
              let x = Math.random() * canvas_width;
              let y = Math.random() * canvas_height;
              context.moveTo(x, y);
              context.lineTo(x + 1, y + 1);
              context.stroke();
            }
            
          },
          handleGoMobileDetail(m=true){
            this.hisBackEvt=()=>{
              this.showDetail=false
              document.title=this.fields.title
              window.removeEventListener('popstate',this.hisBackEvt)
            }
            window.addEventListener("popstate", this.hisBackEvt, false)
            history.pushState('','','#/')
            // document.title = '立刻查询结果'
          },

          centerRheight(){
            this.$nextTick(()=>{
              try {
                centerRheight()
              }catch (e) {

              }
            })
          },
          reset(){
            this.fillData={}
            this.showDetail=false
            this.cap=null
            $('.formCodeImg').click()
            this.centerRheight()
          },

        },
    };
